import {FC, useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {Redirect, useHistory, useLocation} from 'react-router-dom'
import queryString from 'query-string'
import {LoadingPage} from 'components/ui/LoadingPage'
import {generateDynamicPath, WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {useStartProcedureStatus} from 'features/procedures/hooks/useStartProcedureStatus'
import {asyncError} from 'store/actions/asyncError'

interface CreateWithParamsProps {
  employeeId: string
}

export const CreateWithParams: FC<CreateWithParamsProps> = ({employeeId}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [startProcedureStatus] = useStartProcedureStatus()

  useEffect(() => {
    ;(async () => {
      try {
        const res = await startProcedureStatus({
          variables: {
            input: {
              employeeId,
              procedureType: 'health_insurance_qualification_confirmation',
              status: 'draft',
              initialized: false,
            },
          },
        })
        const id = res.data?.startProcedureStatus.procedureStatus.id
        if (id) {
          history.replace(
            generateDynamicPath(WITH_AUTH_ADMIN_PATHS.HEALTH_INSURANCE_QUALIFICATION_CONFIRMATION.FLOW, [
              {pattern: 'id', replacement: id},
            ])
          )
        }
      } catch (err) {
        dispatch(asyncError(err))
      }
    })()
  }, []) // oxlint-disable-line react/exhaustive-deps

  return <LoadingPage />
}

interface SearchParams {
  employee_id?: string
}

export const Create: FC = () => {
  const {search} = useLocation()
  const {employee_id: employeeId}: SearchParams = queryString.parse(search)

  if (!employeeId) {
    return <Redirect to={WITH_AUTH_ADMIN_PATHS.ADDITIONAL_CHILDCARE_LEAVE_ALLOWANCE.INDEX} />
  }

  return <CreateWithParams employeeId={employeeId} />
}
